<template>
  <Toast
    class="app-notification"
    :base-z-index="1000"
  />
</template>

<script setup lang="ts">
import { registerToast } from '@/common/composables/useNotification';
import Toast from 'primevue/toast'
import { useToast } from 'primevue/usetoast';

const toast = useToast();
registerToast(toast)
</script>

<style lang="scss">

.p-toast {
  &.app-notification {
    z-index: 1000;
  }

  .p-toast-message-content {
    min-height: 60px;
  }

  .p-toast-close-button {
    outline: none !important;
    color: #6b7280 !important;
  }

  .p-toast-message {
    border-radius: 6px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    font-family: inherit;
    border: none;

    .p-toast-message-content {
      padding: 12px 16px;
      align-items: center;
      gap: 12px;
    }

    .p-toast-summary {
      font-weight: 600;
      font-size: 15px;
      color: #323248;
    }

    .p-toast-detail {
      font-size: 13px;
      margin-top: 4px;
      opacity: 1;
      color: #4b5563;
    }

    .p-toast-detail:empty {
      display: none;
    }

    &.p-toast-message-success {
      background-color: #fff !important;
      color: #323248;
      border-left: 4px solid var(--p-toast-success-color);
      .p-toast-detail {
        color: color-mix(in srgb, var(--p-toast-success-color) 72%, #323248);
      }
    }

    &.p-toast-message-warn {
      background-color: #fff !important;
      color: #323248;
      border-left: 4px solid var(--p-toast-warn-color);
      .p-toast-detail {
        color: color-mix(in srgb, var(--p-toast-warn-color) 72%, #323248);
      }
    }

    &.p-toast-message-error {
      background-color: #fff !important;
      color: #323248;
      border-left: 4px solid var(--p-toast-error-color);
      .p-toast-detail {
        color: color-mix(in srgb, var(--p-toast-error-color) 72%, #323248);
      }
    }

    &.p-toast-message-info {
      background-color: #fff !important;
      color: #323248;
      border-left: 4px solid var(--p-toast-info-color);
      .p-toast-detail {
        color: color-mix(in srgb, var(--p-toast-info-color) 72%, #323248);
      }
    }

    .p-toast-icon-close:hover {
      background: rgba(255, 255, 255, 0.2);
      border-radius: 50%;
    }
  }
}
</style>
